import { useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Lock, Menu, X } from "lucide-react";

const LINKS = [
  { label: "Início", href: "#inicio", id: "inicio" },
  { label: "Sobre", href: "#sobre", id: "sobre" },
  { label: "Galeria", href: "#galeria", id: "galeria" },
  { label: "Serviços", href: "#servicos", id: "servicos" },
  { label: "Contato", href: "#contato", id: "contato" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-[#09090b]/80 border-b border-[#27272a]/60" data-testid="main-navbar">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-4 flex items-center justify-between">
        <a href="#inicio" aria-label="Dudu Tattoo" data-testid="nav-logo">
          <img src="/logo-dudu.png" alt="Dudu Tattoo Studio" className="h-12 sm:h-14 w-auto" />
        </a>
        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <a key={l.id} href={l.href} data-testid={`nav-link-${l.id}`}
              className="font-mono-dt text-xs uppercase tracking-[0.2em] text-zinc-400 hover:text-[#e2d9cc] transition-colors duration-300">
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <Link to="/admin" data-testid="nav-admin-button" aria-label="Área administrativa"
            className="p-2.5 rounded-md border border-[#27272a] text-zinc-400 hover:text-[#e03131] hover:border-[#e03131]/50 transition-colors duration-300">
            <Lock size={15} />
          </Link>
          <a href="#agendamento" data-testid="nav-agendar-cta"
            className="hidden sm:inline-flex items-center px-5 py-2.5 rounded-md bg-[#e03131] text-white font-mono-dt text-xs uppercase tracking-[0.15em] hover:bg-[#c92a2a] transition-colors duration-300">
            Agendar Sessão
          </a>
          <button className="lg:hidden p-2 text-zinc-300" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="Menu">
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
      <AnimatePresence>
        {open && (
          <motion.nav initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: "auto" }} exit={{ opacity: 0, height: 0 }}
            className="lg:hidden border-t border-[#27272a]/60 bg-[#09090b]/95 overflow-hidden" data-testid="nav-mobile-menu">
            <div className="px-6 py-5 flex flex-col gap-4">
              {LINKS.map((l) => (
                <a key={l.id} href={l.href} onClick={() => setOpen(false)} data-testid={`nav-mobile-link-${l.id}`}
                  className="font-mono-dt text-sm uppercase tracking-[0.2em] text-zinc-300">{l.label}</a>
              ))}
              <a href="#agendamento" onClick={() => setOpen(false)} data-testid="nav-mobile-agendar-cta"
                className="mt-2 inline-flex justify-center px-5 py-3 rounded-md bg-[#e03131] text-white font-mono-dt text-xs uppercase tracking-[0.15em]">
                Agendar Sessão
              </a>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
